import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  Page,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

function Dsp() {
  const classes = globalStyles();
  const history = useHistory();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams?.get("search");
  const paramsPage = urlParams?.get("page");
  const paramsSize = urlParams?.get("size");
  const paramsSort = urlParams.get("sort");

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    sort: paramsSort || "",
  });

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/master/client`, {
        headers,
        params: queryParams,
      });

      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Client">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid container justifyContent="space-between" my="16px">
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Client Name"
              startIcon={<Add />}
              onClick={() => history.push("/admin/parameter/client/add")}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          sortValue={queryParams?.sort}
          onRequestSort={sortBy =>
            handleChangeQueryParams(
              `${sortBy} ${
                queryParams.sort === `${sortBy} asc` ? "desc" : "asc"
              }`,
              "sort"
            )
          }
          isHaveAction
          handleEdit={item =>
            history.push(
              `/admin/parameter/client/edit/${item?.master_client_id}`
            )
          }
          handleView={item =>
            history.push(
              `/admin/parameter/dsp/detail/${item?.master_client_id}`
            )
          }
        />
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Parameter",
    link: "/admin/parameter/dsp",
  },
  {
    label: "Client",
    active: true,
  },
];
const columnTable = [
  {
    name: "name",
    title: "DSP",
    sort_key: "name",
    useSort: true,
  },
  {
    name: "color",
    title: "Identity Color",
    renderText: item => (
      <Box
        height="30px"
        width="30px"
        backgroundColor={item}
        border={`solid 0.5px ${item === "#FFF" && "lightgray"}`}
      />
    ),
  },
  {
    name: "person_name",
    title: "Person In Charge",
    sort_key: "person_name",
    useSort: true,
  },
  {
    name: "person_email",
    title: "Email",
    sort_key: "person_email",
    useSort: true,
  },
  {
    name: "person_phone",
    title: "Phone Number",
    sort_key: "person_phone",
    useSort: true,
  },
];
export default Dsp;
